(function () {
  function getCartSectionIdsGlobal() {
    return Array.prototype.slice.call(document.querySelectorAll('cart-items-component[data-section-id]'))
      .map(function (item) { return item.dataset.sectionId; })
      .filter(Boolean);
  }

  function dispatchCartUpdateGlobal(response, quantity, variantId, sourceId) {
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: response,
        sourceId: sourceId || '',
        data: {
          source: 'product-form-component',
          itemCount: quantity,
          variantId: variantId || '',
          sections: response.sections || {}
        }
      }
    }));
  }

  function openCartDrawerGlobal() {
    var drawer = document.querySelector('cart-drawer-component');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return;
    }

    var drawerTrigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
    if (drawerTrigger) drawerTrigger.click();
  }

  function addCartSectionsGlobal(formData) {
    var sectionIds = getCartSectionIdsGlobal();

    if (sectionIds.length) {
      formData.set('sections', sectionIds.join(','));
      formData.set('sections_url', window.location.pathname);
    }
  }

  function submitCartDataGlobal(formData, quantity, variantId, sourceId) {
    addCartSectionsGlobal(formData);

    return fetch((window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST',
      headers: {
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    })
      .then(function (response) { return response.json(); })
      .then(function (response) {
        if (response.status) {
          throw new Error(response.description || response.message || 'Produsul nu a putut fi adaugat in cos.');
        }

        dispatchCartUpdateGlobal(response, quantity, variantId, sourceId);
        openCartDrawerGlobal();
        return response;
      });
  }

  function setBundleButtonLoadingGlobal(button, isLoading, fallbackSoldOutLabel) {
    if (!button) return;

    var isAvailable = button.dataset.available === 'true';
    var defaultLabel = button.dataset.defaultLabel || button.textContent.trim() || 'Alege aceasta optiune';
    var loadingLabel = button.dataset.loadingLabel || 'Se adauga...';
    var unavailableLabel = button.dataset.soldOutLabel || fallbackSoldOutLabel || 'Stoc indisponibil';

    button.classList.toggle('is-loading', isLoading);
    button.disabled = isLoading || !isAvailable;
    button.textContent = isLoading ? loadingLabel : (isAvailable ? defaultLabel : unavailableLabel);
  }

  function loadLazyMedia(media) {
    if (!media || media.dataset.acmLazyLoaded === 'true') return;

    media.dataset.acmLazyLoaded = 'true';

    if (media.tagName === 'IMG') {
      var lazySrc = media.dataset.acmLazySrc;
      if (!lazySrc) return;

      media.addEventListener('load', function () {
        media.classList.add('is-loaded');
      }, { once: true });
      media.src = lazySrc;
      return;
    }

    if (media.tagName === 'VIDEO') {
      Array.prototype.slice.call(media.querySelectorAll('source[data-src]')).forEach(function (source) {
        source.src = source.dataset.src;
      });

      media.load();

      media.addEventListener('loadeddata', function () {
        media.classList.add('is-loaded');
      }, { once: true });

      if (media.dataset.acmAutoplay === 'true') {
        media.muted = true;
        media.play().catch(function () {});
      }
    }
  }

  function initLazyMedia(scope) {
    var root = scope || document;
    var lazyMedia = Array.prototype.slice.call(root.querySelectorAll('[data-acm-lazy-media]'))
      .filter(function (media) {
        return media.dataset.acmLazyLoaded !== 'true' && media.dataset.acmLazyObserved !== 'true';
      });

    if (!lazyMedia.length) return;

    if (!('IntersectionObserver' in window)) {
      lazyMedia.forEach(loadLazyMedia);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting && entry.intersectionRatio <= 0) return;

        loadLazyMedia(entry.target);
        observer.unobserve(entry.target);
      });
    }, {
      rootMargin: '350px 0px',
      threshold: 0.01
    });

    lazyMedia.forEach(function (media) {
      media.dataset.acmLazyObserved = 'true';
      observer.observe(media);
    });
  }

  function initBundleSection(sectionRoot) {
    if (!sectionRoot || sectionRoot.dataset.acmBundleReady === 'true') return;
    sectionRoot.dataset.acmBundleReady = 'true';

    var bundleButtons = Array.prototype.slice.call(sectionRoot.querySelectorAll('[data-acm-bundle-atc]'));

    bundleButtons.forEach(function (button) {
      setBundleButtonLoadingGlobal(button, false);

      button.addEventListener('click', function () {
        var variantId = button.dataset.variantId;
        var quantity = 1;

        if (!variantId || button.disabled || button.dataset.available !== 'true') return;

        var formData = new FormData();
        formData.set('id', variantId);
        formData.set('quantity', String(quantity));

        setBundleButtonLoadingGlobal(button, true);

        submitCartDataGlobal(formData, quantity, variantId, 'acm-bundle-card')
          .catch(function (error) {
            console.error(error);
            alert(error.message || 'Produsul nu a putut fi adaugat in cos.');
          })
          .finally(function () {
            setBundleButtonLoadingGlobal(button, false);
          });
      });
    });
  }

  function init(root) {
    if (!root || root.dataset.acmReady === 'true') return;
    root.dataset.acmReady = 'true';

    var form = root.querySelector('[data-acm-product-form]');
    var variantInput = root.querySelector('[data-acm-variant-input]');
    var addToCartButton = root.querySelector('.acm-lp__cart-cta');
    var mobileCartButton = root.querySelector('[data-acm-mobile-cart-button]');
    var stock = root.querySelector('[data-acm-stock]');
    var stockText = root.querySelector('[data-acm-stock-text]');
    var price = root.querySelector('[data-acm-current-price]');
    var comparePrice = root.querySelector('[data-acm-compare-price]');
    var savings = root.querySelector('[data-acm-savings]');
    var selectedOption = root.querySelector('[data-acm-selected-option]');
    var ctaLabel = root.querySelector('[data-acm-cta-label]');
    var ctaSeparator = root.querySelector('[data-acm-cta-separator]');
    var ctaPrice = root.querySelector('[data-acm-cta-price]');
    var mobileCtaLabel = root.querySelector('[data-acm-mobile-cta-label]');
    var stickyPrice = root.querySelector('[data-acm-sticky-price]');
    var stickyComparePrice = root.querySelector('[data-acm-sticky-compare-price]');
    var stickyPack = root.querySelector('[data-acm-sticky-pack]');
    var offers = Array.prototype.slice.call(root.querySelectorAll('[data-acm-variant-option]'));
    var bundleButtons = Array.prototype.slice.call(root.querySelectorAll('[data-acm-bundle-atc]'));
    var galleryFrame = root.querySelector('[data-acm-gallery-frame]');
    var galleryImage = root.querySelector('.acm-lp__gallery-product');
    var thumbsFrame = root.querySelector('[data-acm-gallery-thumbs-frame]');
    var thumbsContainer = root.querySelector('.acm-lp__gallery-thumbs');
    var thumbs = thumbsContainer ? Array.prototype.slice.call(thumbsContainer.querySelectorAll('[data-acm-gallery-thumb]')) : [];
    var prev = root.querySelector('[data-acm-gallery-prev]');
    var next = root.querySelector('[data-acm-gallery-next]');
    var selectedThumb = 0;
    var currentOffer = null;
    var addToCartLabel = addToCartButton ? addToCartButton.dataset.acmAddToCartLabel || '' : '';
    var soldOutLabel = addToCartButton ? addToCartButton.dataset.acmSoldOutLabel || 'Stoc indisponibil' : 'Stoc indisponibil';

    function isOfferAvailable(offer) {
      return !!offer && offer.dataset.available === 'true';
    }

    function preloadImage(src) {
      return new Promise(function (resolve) {
        if (!src) {
          resolve();
          return;
        }

        var image = new Image();
        image.onload = function () { resolve(); };
        image.onerror = function () { resolve(); };
        image.src = src;
      });
    }

    function waitForImageElement(image) {
      return new Promise(function (resolve) {
        if (!image) {
          resolve();
          return;
        }

        if (image.complete && image.naturalWidth > 0) {
          resolve();
          return;
        }

        image.addEventListener('load', function () { resolve(); }, { once: true });
        image.addEventListener('error', function () { resolve(); }, { once: true });
      });
    }

    function setMainLoading(isLoading) {
      if (!galleryFrame) return;
      galleryFrame.classList.toggle('is-loading', isLoading);
      galleryFrame.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    }

    function setThumbsLoading(isLoading) {
      if (!thumbsFrame) return;
      thumbsFrame.classList.toggle('is-loading', isLoading);
      thumbsFrame.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    }

    function ensureGalleryImage() {
      if (!galleryImage) return null;

      if (galleryImage.tagName !== 'IMG') {
        var img = document.createElement('img');
        img.className = galleryImage.className;
        img.loading = 'eager';
        img.alt = galleryImage.getAttribute('aria-label') || galleryImage.getAttribute('alt') || '';
        galleryImage.replaceWith(img);
        galleryImage = img;
      }

      return galleryImage;
    }

    function setMainImage(src, alt) {
      var imageNode = ensureGalleryImage();
      if (!src || !imageNode) return Promise.resolve();

      if (imageNode.getAttribute('src') === src || imageNode.currentSrc === src) {
        imageNode.alt = alt || imageNode.alt || '';
        return Promise.resolve();
      }

      setMainLoading(true);

      return preloadImage(src)
        .then(function () {
          imageNode.removeAttribute('srcset');
          imageNode.removeAttribute('sizes');
          imageNode.src = src;
          imageNode.alt = alt || imageNode.alt || '';
        })
        .catch(function () {
          imageNode.removeAttribute('srcset');
          imageNode.removeAttribute('sizes');
          imageNode.src = src;
          imageNode.alt = alt || imageNode.alt || '';
        })
        .finally(function () {
          setMainLoading(false);
        });
    }

    function buildFallbackThumbs(offer) {
      if (!thumbsContainer || !offer || !offer.dataset.variantImage) return false;

      thumbsContainer.innerHTML = '';

      var button = document.createElement('button');
      var image = document.createElement('img');

      button.type = 'button';
      button.className = 'is-active';
      button.setAttribute('data-acm-gallery-thumb', '');
      button.setAttribute('data-media-src', offer.dataset.variantImage);
      button.setAttribute('data-media-alt', offer.dataset.optionLabel || offer.dataset.variantTitle || '');

      image.loading = 'lazy';
      image.alt = offer.dataset.optionLabel || offer.dataset.variantTitle || '';
      image.src = offer.dataset.variantThumb || offer.dataset.variantImage;

      button.appendChild(image);
      thumbsContainer.appendChild(button);

      return true;
    }

    function bindThumbs() {
      thumbs = thumbsContainer ? Array.prototype.slice.call(thumbsContainer.querySelectorAll('[data-acm-gallery-thumb]')) : [];
    }

    function updateThumbControls() {
      var hasMultipleThumbs = thumbs.length > 1;

      if (prev) prev.hidden = !hasMultipleThumbs;
      if (next) next.hidden = !hasMultipleThumbs;
    }

    function syncThumbVisibility(behavior) {
      var thumb = thumbs[selectedThumb];
      if (!thumb || typeof thumb.scrollIntoView !== 'function') return;

      thumb.scrollIntoView({
        behavior: behavior || 'smooth',
        block: 'nearest',
        inline: 'nearest'
      });
    }

    function waitForThumbImages() {
      if (!thumbsContainer) return Promise.resolve();

      var thumbImages = Array.prototype.slice.call(thumbsContainer.querySelectorAll('img')).slice(0, 6);
      return Promise.all(thumbImages.map(waitForImageElement));
    }

    function setThumb(index, options) {
      if (!thumbs.length) return Promise.resolve();

      selectedThumb = (index + thumbs.length) % thumbs.length;

      var thumb = thumbs[selectedThumb];
      thumbs.forEach(function (item) {
        item.classList.toggle('is-active', item === thumb);
      });

      syncThumbVisibility(options && options.instant ? 'auto' : 'smooth');

      return setMainImage(thumb.dataset.mediaSrc, thumb.dataset.mediaAlt);
    }

    function renderVariantGallery(offer) {
      if (!thumbsContainer || !offer) return Promise.resolve(false);

      var template = root.querySelector('[data-acm-variant-gallery-template][data-variant-id="' + offer.dataset.variantId + '"]');
      setThumbsLoading(true);

      if (template) {
        thumbsContainer.innerHTML = template.innerHTML;
      } else if (!buildFallbackThumbs(offer)) {
        setThumbsLoading(false);
        return Promise.resolve(false);
      }

      selectedThumb = 0;
      bindThumbs();
      updateThumbControls();

      return Promise.all([
        waitForThumbImages(),
        setThumb(0, { instant: true })
      ])
        .finally(function () {
          setThumbsLoading(false);
        })
        .then(function () {
          return true;
        });
    }

    function updatePurchaseState(offer) {
      var isAvailable = isOfferAvailable(offer);

      if (stock) {
        stock.classList.toggle('is-unavailable', !isAvailable);
      }

      if (stockText) {
        stockText.textContent = isAvailable
          ? (stock.dataset.availableText || '')
          : (stock.dataset.unavailableText || soldOutLabel);
      }

      if (ctaLabel) {
        ctaLabel.textContent = isAvailable ? addToCartLabel : soldOutLabel;
      }

      if (mobileCtaLabel) {
        mobileCtaLabel.textContent = isAvailable ? addToCartLabel : soldOutLabel;
      }

      if (ctaSeparator) {
        ctaSeparator.hidden = !isAvailable;
      }

      if (ctaPrice) {
        ctaPrice.hidden = !isAvailable;
      }

      if (addToCartButton) {
        addToCartButton.classList.toggle('is-unavailable', !isAvailable);
        addToCartButton.disabled = addToCartButton.classList.contains('is-loading') || !isAvailable;
      }

      if (mobileCartButton) {
        mobileCartButton.classList.toggle('is-unavailable', !isAvailable);
        mobileCartButton.disabled = mobileCartButton.classList.contains('is-loading') || !isAvailable;
      }
    }

    function selectOffer(offer) {
      if (!offer || !isOfferAvailable(offer)) {
        updatePurchaseState(offer);
        return Promise.resolve(false);
      }

      currentOffer = offer;

      offers.forEach(function (item) {
        item.classList.toggle('is-selected', item === offer);
      });

      if (variantInput) variantInput.value = offer.dataset.variantId || variantInput.value;
      if (price) price.textContent = offer.dataset.price || '';
      if (ctaPrice) ctaPrice.textContent = offer.dataset.price || '';
      if (stickyPrice) stickyPrice.textContent = offer.dataset.price || '';
      if (stickyPack) stickyPack.textContent = offer.dataset.optionLabel || offer.dataset.variantTitle || '';
      if (selectedOption) selectedOption.textContent = offer.dataset.optionLabel || offer.dataset.variantTitle || '';

      if (offer.dataset.variantImage) {
        setMainImage(offer.dataset.variantImage, offer.dataset.optionLabel || offer.dataset.variantTitle || '');
      }

      if (comparePrice) {
        if (offer.dataset.comparePrice) {
          comparePrice.hidden = false;
          comparePrice.textContent = offer.dataset.comparePrice;
        } else {
          comparePrice.hidden = true;
          comparePrice.textContent = '';
        }
      }

      if (stickyComparePrice) {
        if (offer.dataset.comparePrice) {
          stickyComparePrice.hidden = false;
          stickyComparePrice.textContent = offer.dataset.comparePrice;
        } else {
          stickyComparePrice.hidden = true;
          stickyComparePrice.textContent = '';
        }
      }

      if (savings) {
        if (offer.dataset.savings) {
          savings.hidden = false;
          savings.textContent = 'Economisesti ' + offer.dataset.savings;
        } else {
          savings.hidden = true;
          savings.textContent = '';
        }
      }

      updatePurchaseState(offer);

      return renderVariantGallery(offer).then(function (didRenderVariantGallery) {
        if (!didRenderVariantGallery && offer.dataset.variantImage) {
          return setMainImage(offer.dataset.variantImage, offer.dataset.optionLabel || offer.dataset.variantTitle || '');
        }

        return didRenderVariantGallery;
      });
    }

    offers.forEach(function (offer) {
      offer.addEventListener('click', function () {
        if (offer.disabled || !isOfferAvailable(offer)) return;
        selectOffer(offer);
      });
    });

    root.querySelectorAll('[data-acm-scroll]').forEach(function (button) {
      button.addEventListener('click', function () {
        var target = root.querySelector(button.dataset.acmScroll) || document.querySelector(button.dataset.acmScroll);
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    bindThumbs();

    if (thumbsContainer) {
      thumbsContainer.addEventListener('click', function (event) {
        var thumb = event.target.closest('[data-acm-gallery-thumb]');
        if (!thumb || !thumbsContainer.contains(thumb)) return;

        event.preventDefault();
        bindThumbs();

        var index = thumbs.indexOf(thumb);
        if (index === -1) return;

        setThumb(index);
      });
    }
    updateThumbControls();

    if (prev) {
      prev.addEventListener('click', function () {
        setThumb(selectedThumb - 1);
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        setThumb(selectedThumb + 1);
      });
    }

    function startAutoplayVideos() {
      root.querySelectorAll('video[autoplay]').forEach(function (video) {
        video.muted = true;
        video.play().catch(function () {});
      });
    }

    startAutoplayVideos();
    document.addEventListener('visibilitychange', startAutoplayVideos);

    function getCartSectionIds() {
      return Array.prototype.slice.call(document.querySelectorAll('cart-items-component[data-section-id]'))
        .map(function (item) { return item.dataset.sectionId; })
        .filter(Boolean);
    }

    function dispatchCartUpdate(response, quantity, variantId, sourceId) {
      var resolvedSourceId = sourceId || (form ? form.id : '');
      var resolvedVariantId = variantId || (variantInput ? variantInput.value : '');

      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: response,
          sourceId: resolvedSourceId,
          data: {
            source: 'product-form-component',
            itemCount: quantity,
            variantId: resolvedVariantId,
            sections: response.sections || {}
          }
        }
      }));
    }

    function openCartDrawer() {
      var drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
        return;
      }

      var drawerTrigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
      if (drawerTrigger) drawerTrigger.click();
    }

    function addCartSections(formData) {
      var sectionIds = getCartSectionIds();

      if (sectionIds.length) {
        formData.set('sections', sectionIds.join(','));
        formData.set('sections_url', window.location.pathname);
      }
    }

    function submitCartData(formData, quantity, variantId, sourceId) {
      addCartSections(formData);

      return fetch((window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js', {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      })
        .then(function (response) { return response.json(); })
        .then(function (response) {
          if (response.status) {
            throw new Error(response.description || response.message || 'Produsul nu a putut fi adaugat in cos.');
          }

          dispatchCartUpdate(response, quantity, variantId, sourceId);
          openCartDrawer();
          return response;
        });
    }

    function setAddToCartLoading(isLoading) {
      if (addToCartButton) {
        addToCartButton.classList.toggle('is-loading', isLoading);
        addToCartButton.disabled = isLoading || !isOfferAvailable(currentOffer);
      }

      if (mobileCartButton) {
        mobileCartButton.classList.toggle('is-loading', isLoading);
        mobileCartButton.disabled = isLoading || !isOfferAvailable(currentOffer);
      }
    }

    function setBundleButtonLoading(button, isLoading) {
      if (!button) return;

      var isAvailable = button.dataset.available === 'true';
      var defaultLabel = button.dataset.defaultLabel || button.textContent.trim() || 'Alege aceasta optiune';
      var loadingLabel = button.dataset.loadingLabel || 'Se adauga...';
      var unavailableLabel = button.dataset.soldOutLabel || soldOutLabel;

      button.classList.toggle('is-loading', isLoading);
      button.disabled = isLoading || !isAvailable;
      button.textContent = isLoading ? loadingLabel : (isAvailable ? defaultLabel : unavailableLabel);
    }

    bundleButtons.forEach(function (button) {
      setBundleButtonLoading(button, false);

      button.addEventListener('click', function () {
        var variantId = button.dataset.variantId;
        var quantity = 1;

        if (!variantId || button.disabled || button.dataset.available !== 'true') return;

        var formData = new FormData();
        formData.set('id', variantId);
        formData.set('quantity', String(quantity));

        setBundleButtonLoading(button, true);

        submitCartData(formData, quantity, variantId, 'acm-bundle-card')
          .catch(function (error) {
            console.error(error);
            alert(error.message || 'Produsul nu a putut fi adaugat in cos.');
          })
          .finally(function () {
            setBundleButtonLoading(button, false);
          });
      });
    });

    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();

        var selected = root.querySelector('[data-acm-variant-option].is-selected');
        if (selected && variantInput) variantInput.value = selected.dataset.variantId;

        if (!isOfferAvailable(selected)) {
          updatePurchaseState(selected);
          return;
        }

        var formData = new FormData(form);
        var quantity = Number(formData.get('quantity')) || 1;

        setAddToCartLoading(true);

        submitCartData(formData, quantity, variantInput ? variantInput.value : '', form.id)
          .catch(function (error) {
            console.error(error);
            alert(error.message || 'Produsul nu a putut fi adaugat in cos.');
          })
          .finally(function () {
            setAddToCartLoading(false);
          });
      });
    }

    var initialOffer = root.querySelector('[data-acm-variant-option].is-selected:not([disabled])') || root.querySelector('[data-acm-variant-option]:not([disabled])');
    if (initialOffer) {
      selectOffer(initialOffer);
    } else {
      updatePurchaseState(null);
    }
  }

  function initAll() {
    document.querySelectorAll('[data-acm-lp]').forEach(init);
    document.querySelectorAll('[data-acm-bundle-section]').forEach(initBundleSection);
    initLazyMedia(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target.querySelector('[data-acm-lp]'));

    var bundleSection = event.target.matches && event.target.matches('[data-acm-bundle-section]')
      ? event.target
      : event.target.querySelector('[data-acm-bundle-section]');
    initBundleSection(bundleSection);
    initLazyMedia(event.target);
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-acm-scroll]');
    if (!button || button.closest('[data-acm-lp]')) return;

    var target = document.querySelector(button.dataset.acmScroll);
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})();
